// Eager slim slice of the canvas method barrel (#15).
//
// The shell imports this instead of `../canvas/methods/index.js` so
// context.methods no longer merges the full ~30-method canvas surface into the
// EAGER chunk. The shell-root Zoombar (mounted on every route — app.js) is the
// only eager consumer of canvas-package methods, and it calls exactly two:
// `bridgeSetWindow` and `openKeyboardShortcuts`.
//
// PREMISE CORRECTION (Rule 63 fix, tickets/workspace.md "duplicate export
// names" #5, 2026-07-27): this used to re-export a function literally named
// `setWindow`, on the claim that shared doesn't already provide one
// ("shared/methods/canvas.js" was checked — it doesn't define it there). That
// premise was FALSE: the real `setWindow` primitive lives in
// `shared/methods/windows.js` and IS exported from the shared barrel
// (`shared/methods/index.js` → `export * from './windows'`). Re-exporting a
// same-named canvas function here meant `workspace/packages/workspace/
// context.js`'s `methods: { ...canvasMethods, ...shellMethods }` baked
// canvas's copy into context.methods.setWindow BEFORE shared's methods ever
// get a chance to fill it in via mergeSharedLibraries (which only adds keys
// the target doesn't already have) — so canvas's narrow v1→v2 bridge shim
// permanently shadowed the real primitive shell-wide, breaking every
// `el.setWindow(...)` call that expected real window state
// (openWindow/closeWindow/toggleWindow, docs/explorer/componentEditor panels
// across shared/components/*). Renamed to `bridgeSetWindow` so it can never
// collide with the real export name again; see the naming note atop
// canvas/methods/index.js for the full explanation + who should call which.
//
// methods/index.js is a single self-contained module (all methods defined
// inline; it does NOT `export *` a fan-out of source files), so a named
// re-export from it pulls no extra editor code.
export { bridgeSetWindow, openKeyboardShortcuts } from './index.js'
